<dv-dynamic-form
  class="dynamic-form"
  formTitle="{{ 'User.PersonalInformation' | translate | uppercase }}"
  [elements]="personalInfoElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'User.Membership' | translate | uppercase }}"
  [elements]="membershipElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form"
  formTitle="{{ 'User.AllowedDepartments' | translate | uppercase }}"
  [elements]="allowedDepartmentsElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="!formGroup.dirty || !formGroup.valid || saveInProgress()"
  (save)="onSave()">
  @if (createdTime()) {
    <span>
      {{ 'User.Created' | translate }}: {{ createdTime() | date: 'dd/MM/yyyy' }}
    </span>
  }
</dv-save-panel>
